import axios from 'axios'
import { createApp } from 'vue'
import { getCookie } from '~/js/cookies'
import { getItemsFromIds } from '~/js/helpers/getProducts'

const ID = 'js-blogContest'
const closeDateTime = new Date(2025, 2, 24).getTime() // 2025年3月23日まで投票可
const isClosed = closeDateTime < new Date().getTime()

document.addEventListener('DOMContentLoaded', async () => {
  const elementBlogContest = document.getElementById(ID)
  if (!elementBlogContest) return

  const articleIdsString = elementBlogContest.dataset.articleIds
  const articleIds = JSON.parse(articleIdsString)
  const articlesOrdered = await getItemsFromIds(articleIds, 'article')
  const articles = articlesOrdered.sort(() => Math.random() - 0.5) // シャッフル

  const { baseUrlFrontApi } = elementBlogContest.dataset

  let votedArticleId = null
  const userId = getCookie('_shopify_y')

  if (userId) {
    try {
      const { data } = await axios.get(
        `${baseUrlFrontApi}/mrc_contest/get_user_vote`,
        {
          params: { uid: userId },
        }
      )
      votedArticleId = data.articleId
    } catch (error) {
      console.error(error)
    }
  }
  createApp({
    name: 'TemplatesBlogContest',
    data() {
      return {
        articles,
        votedArticleId,
        isProcessing: false,
      }
    },
    computed: {
      isButtonDisabled() {
        return (
          !!this.votedArticleId || this.isProcessing || isClosed || undefined
        )
      },
    },
    methods: {
      buttonText(article) {
        return isClosed
          ? '投票終了'
          : article.id == this.votedArticleId
          ? '投票済み'
          : '投票する'
      },
      async onButtonVoteClicked(id) {
        if (this.isButtonDisabled) return
        if (!confirm('このコーディネートに投票します。よろしいですか？')) return
        this.isProcessing = true
        try {
          const { data } = await axios.post(
            `${baseUrlFrontApi}/mrc_contest/vote`,
            {
              userId,
              articleId: id.toString(),
            }
          )
          this.votedArticleId = data.articleId
        } catch (error) {
          console.error(error)
        }
        this.isProcessing = false
      },
    },
  }).mount(elementBlogContest)
})
